let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ifmNt")).then(() => parcelRequire('4lgsB'));